import { Component } from "@angular/core";
import { AuthService } from "../auth/auth.service";

@Component({
  selector: "app-login-loading",
  templateUrl: "./login-loading.component.html",
  styleUrls: ["./login-loading.component.scss"]
})
export class LoginLoadingComponent {

  constructor(
    public readonly authService: AuthService,
  ) { }
}
